import { Link } from "react-router-dom";
import { formSubmissionForms } from "../../../utils/form-submissions";

export default function AdminFormSubmissions() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Form submissions</h1>
      <div className="bg-white rounded-lg shadow divide-y divide-gray-100">
        {formSubmissionForms.map(({ id, label }) => (
          <Link key={id} to={`/admin/form-submissions/${id}`} className="block px-5 py-4 text-sm hover:bg-gray-50">
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
}
